import { VoiceAIConfig } from '../client';
import { LLMMessage, LLMOptions, LLMResult } from '../llm';
import { makeRequest } from '../utils/request';

export interface LLMProvider {
  complete: (messages: LLMMessage[], options: LLMOptions, config: VoiceAIConfig) => Promise<LLMResult | ReadableStream>;
}

export const LLMProviders: Record<string, LLMProvider> = {
  'llama-4-scout': {
    complete: async (messages, options, config) => {
      const response = await makeRequest({
        url: '/v1/llm/llama-4-scout',
        method: 'POST',
        data: {
          messages,
          temperature: options.temperature,
          max_tokens: options.maxTokens,
          top_p: options.topP,
          stream: options.stream,
        },
        responseType: options.stream ? 'stream' : 'json',
        config,
      });

      if (options.stream) {
        return response as ReadableStream;
      }

      return {
        content: response.choices?.[0]?.message?.content || response.response,
        usage: response.usage ? {
          promptTokens: response.usage.prompt_tokens,
          completionTokens: response.usage.completion_tokens,
          totalTokens: response.usage.total_tokens,
        } : undefined,
      };
    },
  },

  'general': {
    complete: async (messages, options, config) => {
      const prompt = messages.map(m => `${m.role}: ${m.content}`).join('\n');
      
      const response = await makeRequest({
        url: '/v1/llm',
        method: 'POST',
        data: {
          prompt,
          model: options.model,
        },
        responseType: 'json',
        config,
      });

      return {
        content: response.response,
      };
    },
  },
};